export const baseUrl = {
    development: process.env.DOMAIN_URL || 'https://bumble.com',
    test: process.env.DOMAIN_URL || 'https://bumble.com',
    production: process.env.DOMAIN_URL || 'https://bumble.com',
}[process.env.NODE_ENV];
